import React from 'react';

const RecipesHeader = () => {
  return (
    <h1>Recipes</h1>
  );
};

export default RecipesHeader;
